// src/utils/numberToWords.js

// Function to convert numbers to words (simple implementation for INR)
const numberToWords = (num) => {
  const units = [
    "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten",
    "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"
  ];
  const tens = [
    "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"
  ];

  const convertLessThanThousand = (n) => {
    if (n === 0) return "";
    if (n < 20) return units[n];
    if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + units[n % 10] : "");
    return units[Math.floor(n / 100)] + " Hundred" + (n % 100 !== 0 ? " " + convertLessThanThousand(n % 100) : "");
  };

  const number = Math.floor(Number(num) || 0);
  if (number === 0) return "Zero Rupees Only";

  let words = "";
  let remaining = number;

  if (remaining >= 10000000) {
    words += convertLessThanThousand(Math.floor(remaining / 10000000)) + " Crore ";
    remaining %= 10000000;
  }
  if (remaining >= 100000) {
    words += convertLessThanThousand(Math.floor(remaining / 100000)) + " Lakh ";
    remaining %= 100000;
  }
  if (remaining >= 1000) {
    words += convertLessThanThousand(Math.floor(remaining / 1000)) + " Thousand ";
    remaining %= 1000;
  }
  if (remaining > 0) {
    words += convertLessThanThousand(remaining);
  }
  return words.trim() + " Rupees Only";
};

export default numberToWords;